/* ----------------------------------------------------------------------------
   Intervention-Analytics scoped MUI theme — aligned with global palette.
   Applied via nested <ThemeProvider> in InterventionLayout so the global
   ProShip theme is untouched.
   ---------------------------------------------------------------------------- */
import { createTheme } from '@mui/material/styles'
import palette from '../../../theme/palette'

const INTER = "'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif"

const interventionTheme = createTheme({
  palette: {
    mode: 'light',
    primary:   { main: palette.primary.main, dark: palette.primary.dark, light: palette.primary.lighter, contrastText: palette.primary.contrastText },
    secondary: { main: '#E85D3A', dark: '#C44425', light: '#FDF0EC', contrastText: '#fff' },
    success:   { main: palette.success.main, light: palette.success.lighter },
    warning:   { main: palette.warning.main, light: palette.warning.lighter },
    error:     { main: palette.error.main, light: palette.error.lighter },
    info:      { main: palette.info.main, light: palette.info.lighter },
    text:      { primary: palette.text.primary, secondary: palette.text.secondary, disabled: palette.text.disabled },
    divider:   palette.divider,
    background: { default: palette.background.default, paper: palette.background.paper },
    action:    { hover: palette.action.hover, selected: palette.action.selected },
  },
  shape: { borderRadius: 6 },
  typography: {
    fontFamily: INTER,
    fontWeightMedium: 600,
    h4: { fontFamily: INTER, fontWeight: 700, fontSize: '1.5rem' },
    h5: { fontFamily: INTER, fontWeight: 700, fontSize: '1.25rem' },
    h6: { fontFamily: INTER, fontWeight: 700, fontSize: '1.1rem' },
    subtitle1: { fontFamily: INTER, fontWeight: 600, fontSize: '0.95rem' },
    subtitle2: { fontFamily: INTER, fontWeight: 600, fontSize: '0.85rem' },
    body1: { fontSize: '0.875rem' },
    body2: { fontSize: '0.8125rem' },
    caption: { fontSize: '0.75rem', color: palette.text.secondary },
    button: { fontFamily: INTER, fontWeight: 600, textTransform: 'none' },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: 'none', fontWeight: 600, borderRadius: 6 } },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: `1px solid ${palette.grey[300]}`,
          borderRadius: 8,
        },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600, fontSize: '0.75rem' } } },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600, minWidth: 100 } } },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: palette.grey[900], fontSize: '11.5px', fontWeight: 500, borderRadius: 6 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 700, fontSize: '0.8rem', color: palette.text.secondary, backgroundColor: palette.background.default },
        body: { fontSize: '0.8125rem' },
      },
    },
  },
})

export default interventionTheme
